export default {
    list: {
        title: "Notice Center",
        desc: "Browse the latest updates, events, feature changes, and redemption notices from JX3BOX.",
        searchPlaceholder: "Search by keyword",
        sticky: "Pinned",
        empty: "No notices in this category.",
        jump: "Go",
        authorDefault: "JX3BOX",
        tabs: {
            all: "All",
            notice: "Notices",
            information: "Events",
            feature: "Updates",
            message: "Redemption",
        },
    },
    single: {
        back: "Back to list",
        lastUpdated: "Last updated: {date}",
        views: "{count} views",
        edit: "Edit",
        manage: "Manage",
        like: "Like ({count})",
        star: "Favorite",
        starred: "Favorited",
        comments: "Comments",
        commentsClosed: "Comments are disabled for this notice.",
        visibilityTip: "Visibility: {visibility}",
        visibility: {
            public: "Public",
            self: "Only me",
            friends: "Friends only",
            password: "Password protected",
            paid: "Paid",
            fans: "Fans only",
        },
    },
};
